import { Component } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Globals } from '../../globals'
import { ISelectedStudent } from '../../Models/ISelectedStudent';

@Component({
  selector: 'StudentServices',
  templateUrl: './StudentServices.component.html',
})
export class StudentServicesComponent {
  _myGlobals: Globals;
  selectedStudent: ISelectedStudent;
  stdSerMenuItems = [
    { label: 'Child-Find Follow-up', command: (event: Event) => { this._myGlobals.stdSerSelected = 'childFindFollowup' } },
    { label: 'SPT Process', command: (event: Event) => { this._myGlobals.stdSerSelected = 'sptProcess' } }
  ];

  constructor(private globals: Globals) {
    this._myGlobals = globals;
  }

}
